// extracted by mini-css-extract-plugin
module.exports = {"container":"StripeCapitalTile_container__1jma8"};